import { ShopModelCarousal } from "../../../../constants/jsonConstant";
import { useState, useEffect } from "react";
import ImageGallery from "react-image-gallery";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import CreateOutlinedIcon from "@mui/icons-material/CreateOutlined";

import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import RedoIcon from "@mui/icons-material/Redo";
import { Container, Row, Col } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import url from "../../../../config/axios";
import moment from "moment";
import { useSelector } from "react-redux";
import { SuccessNotify, FailedNotify } from "../../../../constants/tostify";
import Loader from "../../../../components/Loader";
import ShareModel from "../../../../components/Sharemodel";
import ShareOption from "../../../../components/Shareoption";
import BackArrow from "../../../../components/backArrow";
import { getAsset } from "../../../../helpers/helper";
import { MainModal } from "@/components";
import "./style.css";
const Vehicleaddshow = () => {
  const { name } = useSelector((state) => state.user);
  const { id } = useParams();
  const { shopid } = useParams();
  const navigate = useNavigate();
  const handleClose = () => setShows(0);
  const [isloading, setIsloading] = useState(false);
  const [increase, setIncrease] = useState(1);
  const [showmodal, setShowmodal] = useState(false);
  const [showshare, setShowshare] = useState(false);
  const [itemsdata, setItemsData] = useState();
  const [show, setShow] = useState(0);
  const [shows, setShows] = useState(false);

  useEffect(() => {
    if (itemsdata) {
      const thumimgs = document?.querySelectorAll(
        ".image-gallery-thumbnail-image",
      );

      thumimgs?.forEach((element) => {
        element?.setAttribute("crossorigin", "anonymous");
      });
    }
  }, [itemsdata]);

  useEffect(() => {
    if (itemsdata) {
      const img = document?.querySelectorAll(".image-gallery-image");

      img?.forEach((element) => {
        element?.setAttribute("crossorigin", "anonymous");
      });
    }
  }, [itemsdata]);

  const Deleteitem = () => {
    setIsloading(true);
    url
      .delete(`sellvehicle/?id=${id}`)
      .then(async (response) => {
        if (response.data.success) {
          setIsloading(false);
          setShows(0);
          SuccessNotify("Item Deleted Successfully");

          navigate(`/used-vehicle-profile/${shopid}`);
        }
      })
      .catch((e) => {
        setIsloading(false);
        FailedNotify("Failed to Delete Try Again!");
      });
  };

  useEffect(() => {
    url.get(`sellvehicle/id/?id=${id}`).then(async (res) => {
      setItemsData(res.data.data.SellVehicle);
    });
  }, []);

  if (isloading) {
    return (
      <Container>
        <div className="vehicle-addshow-mobile-back d-lg-none">
          <BackArrow />
        </div>
        <div className="vehicle-addshow-loading">
          <Loader heightsetting="screenHeight" />
        </div>
      </Container>
    );
  }

  const handleClosemodal = () => setShowmodal(false);
  const handleCloseshare = () => setShowshare(false);
  const handleShowshare = () => setShowshare(true);

  const ShopModelCarousal =
    itemsdata?.images?.map((image, index) => ({
      id: index + 1,
      original: getAsset(image),
      thumbnail: getAsset(image),
    })) || [];

  return (
    <>
      <ShareOption showshare={showshare} handleCloseshare={handleCloseshare} />
      <ShareModel
        show={showmodal}
        handleClosemodal={handleClosemodal}
        handleShowshare={handleShowshare}
        shopid={shopid}
        shareurl={`/used-vehicle-profile/${shopid}`}
      />
      {shows === 1 && (
        <MainModal
          variant="deleteModal"
          show={shows}
          title="Profile"
          handleClose={handleClose}
          animation={true}
          handledelete={Deleteitem}
        />
      )}
      <Container>
        <div className="vehicle-addshow-mobile-back d-lg-none">
          <BackArrow />
        </div>
        <div className="screenHeight vehicle-addshow-content">
          <div className="ps-5">
            <h5>{itemsdata?.createdAt}</h5>
          </div>
          <Row>
            <Col lg="6">
              <div className="row">
                <ImageGallery
                  showPlayButton={false}
                  showFullscreenButton={false}
                  items={ShopModelCarousal}
                />
              </div>
            </Col>
            <Col lg="6" md="12" sm="12">
              <div className="ps-4 pe-4 pt-4 pb-3 bg-vilot View-Model-Shadow">
                {/* Header */}
                <Row>
                  <Col
                    lg="6"
                    md="6"
                    sm="6"
                    xs="6"
                    className="text-start d-none d-lg-block"
                  >
                    <BackArrow />
                  </Col>
                  <Col
                    lg="6"
                    md="6"
                    sm="6"
                    xs="6"
                    className="text-end vehicle-addshow-share"
                  >
                    <button
                      className="shareItembtn"
                      onClick={() => setShowmodal(true)}
                    >
                      Share <RedoIcon className="share_icon_f" />
                    </button>
                  </Col>
                </Row>

                {/* Row 1 */}
                <Row className="mt-2 font-sm">
                  <Col lg="3" md="6" sm="12">
                    <label className="form-label">Model</label>
                    <p className="p-2 border_3 mb-0">{itemsdata?.modelYear}</p>
                  </Col>
                  <Col lg="3" md="6" sm="12">
                    <label className="form-label">Registered In</label>
                    <p className="p-2 border_3 mb-0">
                      {moment(itemsdata?.registeredIn).format("DD-MMMM-YYYY")}
                    </p>
                  </Col>
                  <Col lg="3" md="6" sm="12">
                    <label className="form-label">Mileage (km)</label>
                    <p className="p-2 border_3 mb-0">{itemsdata?.mileage}</p>
                  </Col>
                  <Col lg="3" md="6" sm="12">
                    <label className="form-label">Assembly</label>
                    <p className="p-2 border_3 mb-0">{itemsdata?.assembly}</p>
                  </Col>
                </Row>

                {/* Row 2 */}
                <Row className="mt-2 font-sm">
                  <Col lg="3" md="6" sm="12">
                    <label className="form-label">Version</label>
                    <p className="p-2 border_3 mb-0">{itemsdata?.version}</p>
                  </Col>
                  <Col lg="3" md="6" sm="12">
                    <label className="form-label">Make</label>
                    <p className="p-2 border_3 mb-0">{itemsdata?.make}</p>
                  </Col>
                  <Col lg="3" md="6" sm="12">
                    <label className="form-label">Engine Capacity (cc)</label>
                    <p className="p-2 border_3 mb-0">
                      {itemsdata?.engineCapactiy}
                    </p>
                  </Col>
                  <Col lg="3" md="6" sm="12">
                    <label className="form-label">Color</label>
                    <p className="p-2 border_3 mb-0">{itemsdata?.color}</p>
                  </Col>
                </Row>

                {/* Row 3 */}
                <Row className="mt-2 font-sm">
                  <Col lg="3" md="6" sm="12">
                    <label className="form-label">Transmission</label>
                    <p className="p-2 border_3 mb-0">
                      {itemsdata?.transmission}
                    </p>
                  </Col>
                  <Col lg="3" md="6" sm="12">
                    <label className="form-label">City</label>
                    <p className="p-2 border_3 mb-0">{itemsdata?.city}</p>
                  </Col>
                  <Col lg="3" md="6" sm="12">
                    <label className="form-label">City Area</label>
                    <p className="p-2 border_3 mb-0">{itemsdata?.cityArea}</p>
                  </Col>
                  <Col lg="3" md="6" sm="12">
                    <label className="form-label">Engine Type</label>
                    <p className="p-2 border_3 mb-0">{itemsdata?.engineType}</p>
                  </Col>
                </Row>

                {/* Description */}
                <p className="fw-lighter mt-2">{itemsdata?.description}</p>

                {/* Price */}
                <div>
                  <h3 className="font-blue">{itemsdata?.price}</h3>
                </div>

                {/* Contact */}
                <div>
                  <p className="mb-0">Contact us on</p>
                  <p className="mb-0 pt-2 pb-2">{name.email}</p>
                  <p className="mb-0">{name.phonenumber}</p>
                </div>

                {/* Quantity Box (Responsive) */}
                <div className="bg-white quantityBox mt-3 mb-3 pe-2 ps-2 d-flex align-items-center">
                  <p className="mb-0 pe-2">QTY:</p>
                  <p className="mb-0 pe-2">{increase}</p>
                  <div className="d-flex flex-column align-items-center">
                    <ExpandLessIcon
                      fontSize="small"
                      onClick={() => setIncrease(increase + 1)}
                    />
                    <ExpandMoreIcon
                      fontSize="small"
                      onClick={() => increase > 1 && setIncrease(increase - 1)}
                    />
                  </div>
                </div>

                {/* Action Buttons */}
                <div className="pt-3 d-flex flex-wrap pb-3">
                  <button
                    className="d-flex align-items-center border rounded ps-3 pe-3 pt-1 pb-1 bg-red text-white"
                    onClick={() => setShows(1)}
                  >
                    <DeleteOutlineOutlinedIcon />
                    <span className="ps-1">Delete</span>
                  </button>

                  <button
                    className="d-flex align-items-center border rounded ps-4 pe-4 pt-1 pb-1 bg-blue ms-3 me-3 text-white"
                    onClick={() =>
                      navigate(`/update-use-vehicle/${itemsdata?._id}`)
                    }
                  >
                    <CreateOutlinedIcon />
                    <span className="ps-1">Edit</span>
                  </button>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </>
  );
};

export default Vehicleaddshow;
